function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("649ic", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$d5d63461604d4a87$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $i8Qvm;
    var $pa9q9;
    var $lfTZh;
    var $DVljb;
    var $9OXo1;
    var $7iULw;
    var $dseDh;
    var $cwiML;
    var $1wKiN;
    var $iWD4e;
    var $7yOuR;
    const $d5d63461604d4a87$var$FeedbackRenderer = ()=>{
        const locale = (0, (0, parcelRequire("DVljb")).useNativeLocale)();
        const [{ isFeedbackCollectorOpen: isFeedbackCollectorOpen, feedbackCollectorId: feedbackCollectorId, additionalFields: additionalFields, feedbackContext: feedbackContext, feedbackGroupId: feedbackGroupId, onClose: onClose, onSubmit: onSubmit, entrypointId: entrypointId, renderCustomContent: renderCustomContent, ...feedbackCollectorProps }, { closeFeedbackCollector: closeFeedbackCollector, resetFeedbackCollectorState: resetFeedbackCollectorState }] = (0, (0, parcelRequire("dseDh")).useFeedbackCollector)();
        const { userFullname: userFullname, atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const additionalFieldsWithContext = (0, $5uXOq.useMemo)(()=>{
            const fields = additionalFields?.slice() ?? [];
            let maybeFeedbackContext = feedbackContext;
            if (feedbackGroupId != null) {
                maybeFeedbackContext = maybeFeedbackContext || [];
                maybeFeedbackContext.push({
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).FEEDBACK_GROUP_ID,
                    value: feedbackGroupId
                });
            }
            if (maybeFeedbackContext != null) fields.push({
                id: (0, $97431fdd4a86ccff$export$c14d5836f440dde1),
                value: maybeFeedbackContext.map(({ id: id, value: value })=>`${id}: ${String(value)}`).join('\n')
            });
            return fields;
        }, [
            additionalFields,
            feedbackContext,
            feedbackGroupId
        ]);
        const onFeedbackSubmit = (0, $5uXOq.useCallback)((feedbackDetails)=>{
            const analyticsPayload = (0, (0, parcelRequire("7yOuR")).createAnalyticsPayload)(feedbackCollectorId, feedbackDetails);
            (0, (0, parcelRequire("cwiML")).fireFeedbackCreatedAnalytics)(entrypointId, analyticsPayload);
            showFlag((0, (0, parcelRequire("iWD4e")).successFlagConfig));
            onSubmit?.();
            resetFeedbackCollectorState();
        }, [
            onSubmit,
            entrypointId,
            feedbackCollectorId,
            resetFeedbackCollectorState,
            showFlag
        ]);
        const onFeedbackClose = (0, $5uXOq.useCallback)(()=>{
            closeFeedbackCollector();
            onClose?.();
        }, [
            closeFeedbackCollector,
            onClose
        ]);
        const shouldRender = isFeedbackCollectorOpen && !!entrypointId;
        const [description, setDescription] = (0, $5uXOq.useState)('');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-feedback-collector-dialog",
            fallback: null
        }, shouldRender ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wKiN")).LazyFeedbackCollectorDialog), {
            locale: locale,
            entrypointId: entrypointId,
            atlassianAccountId: atlassianAccountId,
            anonymousFeedback: isAnonymous,
            onClose: onFeedbackClose,
            onSubmit: onFeedbackSubmit,
            additionalFields: additionalFieldsWithContext,
            name: userFullname ?? undefined,
            customContent: renderCustomContent?.({
                setDescription: setDescription
            }),
            descriptionDefaultValue: description,
            summaryDefaultValue: description,
            ...feedbackCollectorProps
        }) : null));
    };
    var $d5d63461604d4a87$export$2e2bcd8739ae039 = $d5d63461604d4a87$var$FeedbackRenderer;
});
parcelRegister("DVljb", function(module, exports) {
    $parcel$export(module.exports, "useLocale", ()=>$7c760643dc748494$export$43bb16f9c6d9e3f7);
    $parcel$export(module.exports, "useNativeLocale", ()=>$7c760643dc748494$export$31652d9c30d7d3f3);
    var $5uXOq = parcelRequire("5uXOq");
    var $lzeFL;
    var $9OXo1;
    const $7c760643dc748494$export$43bb16f9c6d9e3f7 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.locale || (0, (0, parcelRequire("lzeFL")).defaultLocale);
    };
    const $7c760643dc748494$export$31652d9c30d7d3f3 = ()=>{
        const locale = $7c760643dc748494$export$43bb16f9c6d9e3f7();
        const standardizedLocale = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("lzeFL")).standardizeLocale)(locale), [
            locale
        ]);
        return standardizedLocale;
    };
});
parcelRegister("7iULw", function(module, exports) {
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", ()=>$384a8a865c8f714d$export$baea5c8192e79adc);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", ()=>$384a8a865c8f714d$export$4eda1e3a4a311d13);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", ()=>$384a8a865c8f714d$export$5fb38521eb7ad63c);
    $parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", ()=>$384a8a865c8f714d$export$345c45dd28f28a32);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", ()=>$384a8a865c8f714d$export$8962f2e618411469);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", ()=>$384a8a865c8f714d$export$7d7f2319141db3c5);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", ()=>$384a8a865c8f714d$export$4725635e6fe1907a);
    $parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", ()=>$384a8a865c8f714d$export$3a50f2efd6cfd6f3);
    $parcel$export(module.exports, "ENTRY_POINT_ID_AIOPS", ()=>$384a8a865c8f714d$export$5bd148c13bb23f7a);
    $parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", ()=>$384a8a865c8f714d$export$b4de0744c1fd450d);
    $parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", ()=>$384a8a865c8f714d$export$1a7c42187130faf9);
    $parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", ()=>$384a8a865c8f714d$export$e84c34a7e1dbcf78);
    $parcel$export(module.exports, "ENTRYPOINT_ID_NAVIGATION_REFRESH", ()=>$384a8a865c8f714d$export$23f6d7b16d2210c1);
    $parcel$export(module.exports, "ENTRY_POINT_ID_AUTODEV", ()=>$384a8a865c8f714d$export$1b65c2053cba0686);
    $parcel$export(module.exports, "EntryKeys", ()=>$384a8a865c8f714d$export$12d01b6c311a909a);
    const $384a8a865c8f714d$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
    const $384a8a865c8f714d$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
    const $384a8a865c8f714d$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
    const $384a8a865c8f714d$export$4a288e389131b3de = 'b6176efc-e703-426b-b4f8-3e43ce4aa0db';
    const $384a8a865c8f714d$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
    const $384a8a865c8f714d$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
    const $384a8a865c8f714d$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
    const $384a8a865c8f714d$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
    const $384a8a865c8f714d$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
    const $384a8a865c8f714d$export$5bd148c13bb23f7a = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';
    const $384a8a865c8f714d$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
    const $384a8a865c8f714d$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
    const $384a8a865c8f714d$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
    const $384a8a865c8f714d$export$23f6d7b16d2210c1 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
    const $384a8a865c8f714d$export$1b65c2053cba0686 = '88d39839-ba5c-4704-bfd6-7fe57ed8016b';
    const $384a8a865c8f714d$export$12d01b6c311a909a = Object.freeze({
        CLOUD_ID: 'cloud-id',
        OPT_OUT: 'Opt-out',
        REASON: 'reason',
        FEELING: 'feeling',
        IS_ADMIN: 'is-admin',
        IS_SITE_ADMIN: 'is-site-admin',
        IS_PROJECT_SETTINGS: 'is-project-settings',
        INLINE_FEEDBACK_ID: 'inlineFeedbackId',
        IS_JSD_EVALUATOR: 'is-jsd-evaluator',
        IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
        SUPPORTED_PROJECT_TYPES: 'supported-project-types',
        FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
        FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
        FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
        LOCATION: 'Location',
        PROJECT_TYPE: 'project-type',
        BOARD_TYPE: 'board-type',
        REFERER: 'Referer',
        ROUTE_GROUP: 'route-group',
        ROUTE_NAME: 'route-name',
        USER_AGENT: 'User-Agent',
        SCREEN_RESOLUTION: 'Screen Resolution',
        SOURCE: 'Source',
        SUB_PRODUCT: 'Sub-product',
        JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
        JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
        DEPLOYMENT_PROVIDERS: 'deployment-providers',
        JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
        VERSION_CONTROL_PROVIDERS: 'version-control-providers',
        DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
        CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
        SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
        INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
        IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
        FEEDBACK_GROUP_ID: 'feedback-group-id',
        EDITION: 'edition',
        ENV: 'environment',
        SMART_REPLIES: 'smart-replies'
    });
});
parcelRegister("dseDh", function(module, exports) {
    $parcel$export(module.exports, "useFeedbackCollector", ()=>$c996142feb877ddb$export$4be696be8a3bff13);
    $parcel$export(module.exports, "useFeedbackCollectorActions", ()=>$c996142feb877ddb$export$dfb2ee2d9e73fa48);
    $parcel$export(module.exports, "FeedbackActionsSubscriber", ()=>$c996142feb877ddb$export$c35dbf16ebe9df04);
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    const $c996142feb877ddb$export$d4c72bab9d6cc13a = {
        isFeedbackCollectorOpen: false,
        entrypointId: undefined,
        email: undefined,
        additionalFields: undefined,
        feedbackTitle: undefined,
        feedbackContext: undefined,
        feedbackCollectorId: undefined,
        showTypeField: true,
        submitButtonLabel: undefined,
        canBeContactedLabel: undefined,
        summaryPlaceholder: undefined,
        feedbackGroupLabels: undefined,
        onClose: undefined,
        feedbackTitleDetails: undefined,
        triggerRef: undefined,
        renderCustomContent: undefined,
        customFeedbackOptions: []
    };
    const $c996142feb877ddb$export$e324594224ef24da = {
        openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
                dispatch($c996142feb877ddb$export$e324594224ef24da.resetFeedbackCollectorState());
                setState({
                    ...feedbackCollectorProps,
                    isFeedbackCollectorOpen: true
                });
            },
        closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
                const { triggerRef: triggerRef } = getState();
                if (triggerRef) setTimeout(()=>triggerRef.current?.focus(), 50);
                setState({
                    isFeedbackCollectorOpen: false,
                    triggerRef: undefined
                });
            },
        resetFeedbackCollectorState: ()=>({ setState: setState })=>{
                setState({
                    ...$c996142feb877ddb$export$d4c72bab9d6cc13a
                });
            },
        updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
                setState({
                    renderCustomContent: updatedCustomRenderContent
                });
            },
        updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
                setState({
                    additionalFields: updatedAdditionalFields
                });
            }
    };
    const $c996142feb877ddb$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'feedback-collector',
        initialState: $c996142feb877ddb$export$d4c72bab9d6cc13a,
        actions: $c996142feb877ddb$export$e324594224ef24da
    });
    const $c996142feb877ddb$export$4be696be8a3bff13 = (0, (0, parcelRequire("3sQ5x")).createHook)($c996142feb877ddb$var$Store);
    const $c996142feb877ddb$export$dfb2ee2d9e73fa48 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($c996142feb877ddb$var$Store);
    const $c996142feb877ddb$export$c35dbf16ebe9df04 = (0, (0, parcelRequire("51nlc")).createSubscriber)($c996142feb877ddb$var$Store, {
        selector: null
    });
});
parcelRegister("cwiML", function(module, exports) {
    $parcel$export(module.exports, "fireFeedbackCreatedAnalytics", ()=>$898d4654950bbfff$export$f69def16ab840819);
    var $fjcgS;
    var $7iULw;
    const $898d4654950bbfff$var$allowedAttributes = [
        'feedback-collector-id',
        'reason',
        'feeling',
        (0, (0, parcelRequire("7iULw")).EntryKeys).IS_ATLASKIT_FEEDBACK_COMPONENT
    ];
    const $898d4654950bbfff$var$getAnalyticsPayloadFromAdditionalEntries = (additionalFeedbackEntries)=>{
        const payload = {};
        additionalFeedbackEntries.forEach((entry)=>{
            if ($898d4654950bbfff$var$allowedAttributes.includes(entry.key)) payload[entry.key] = entry.value || 'empty';
        });
        return payload;
    };
    const $898d4654950bbfff$export$f69def16ab840819 = async (entrypointId, request)=>{
        const fullAnalyticsId = 'jira-jsd-widget-feedback.feedback';
        const { additionalFeedbackEntries: additionalFeedbackEntries } = request;
        const gasV3Event = {
            action: 'created',
            actionSubject: fullAnalyticsId,
            source: 'jira-jsd-widget-feedback',
            attributes: {
                ...$898d4654950bbfff$var$getAnalyticsPayloadFromAdditionalEntries(additionalFeedbackEntries),
                entrypointId: entrypointId
            }
        };
        const analyticsClient = await (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)();
        analyticsClient.getInstance().sendOperationalEvent(gasV3Event);
    };
});
const $97431fdd4a86ccff$export$c14d5836f440dde1 = 'customfield_10047';
parcelRegister("1wKiN", function(module, exports) {
    $parcel$export(module.exports, "LazyFeedbackCollectorDialog", ()=>$ce58201ea3a2dad1$export$b3688097311920df);
    var $kxZPA;
    const $ce58201ea3a2dad1$export$b3688097311920df = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("kJQ13")), {
        ssr: false,
        moduleId: "../platform/packages/web-platform/feedback-collector/src/index.ts"
    });
});
parcelRegister("kJQ13", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("aOfb9")
    ]).then(()=>parcelRequire('ncXSS'));
});
parcelRegister("iWD4e", function(module, exports) {
    $parcel$export(module.exports, "successFlagConfig", ()=>$fb2a8b20eb11a2a8$export$9147e75154c63ed3);
    var $aXQSs;
    const $fb2a8b20eb11a2a8$export$9147e75154c63ed3 = {
        type: 'success',
        title: (0, (0, parcelRequire("aXQSs")).default).feedbackSuccessFlagTitle,
        description: (0, (0, parcelRequire("aXQSs")).default).feedbackSuccessFlagDescription,
        isAutoDismiss: true
    };
});
parcelRegister("aXQSs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$244bc206024683ee$export$2e2bcd8739ae039);
    var $7VHMR;
    var $244bc206024683ee$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        feedbackSuccessFlagDescription: {
            "id": "platform.feedback.feedback-collector.feedback-renderer.success-flag.feedback-success-flag-description",
            "defaultMessage": "Your valuable feedback helps us continually improve our products."
        },
        feedbackSuccessFlagTitle: {
            "id": "platform.feedback.feedback-collector.feedback-renderer.success-flag.feedback-success-flag-title",
            "defaultMessage": "Thanks!"
        }
    });
});
parcelRegister("7yOuR", function(module, exports) {
    $parcel$export(module.exports, "createAnalyticsPayload", ()=>$faa9611a44d347d0$export$182a3169dfe1f3d8);
    var $7iULw;
    const $faa9611a44d347d0$export$182a3169dfe1f3d8 = (feedbackCollectorId, feedbackDetails)=>({
            additionalFeedbackEntries: [
                {
                    key: (0, (0, parcelRequire("7iULw")).EntryKeys).FEEDBACK_COLLECTOR_ID,
                    value: feedbackCollectorId ?? 'empty'
                },
                {
                    key: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_ATLASKIT_FEEDBACK_COMPONENT,
                    value: 'true'
                },
                ...feedbackDetails.type ? [
                    {
                        key: (0, (0, parcelRequire("7iULw")).EntryKeys).REASON,
                        value: feedbackDetails.type
                    }
                ] : []
            ]
        });
});
